import React from 'react'
import showTimesPropTypes from '@/shape/show-time'

import Type from '@/component/Primitive/Type'
import Icon from '@/component/Primitive/Icon'
import MovieIcon from '@/asset/img/redesign24/movie.svg'
import styles from './ShowTime.module.scss'
import classNames from 'classnames'

const ShowTime = ({ location, distance, nextShowing, times, layoutV2 }) => {
  const formattedLocation = location.split(':')
  if (layoutV2) {
    return (
      <li className={styles.LayoutV2}>
        <div className={styles.Heading}>
          <span className={styles.MovieIcon}>
            <img src={MovieIcon} alt="location" />
          </span>

          <span className={styles.Location}>{formattedLocation[0]}:</span>
          <span className={styles.Distance}>
            {formattedLocation[1]} ({distance} mi)
          </span>
        </div>
        <div className={styles.TimeListV2}>
          <Icon type="clock" width={26} a11yText="Time" />
          <a href={nextShowing.link} target="_blank" rel="noreferrer">
            <span>
              <strong>Next Showing:</strong>{' '}
            </span>
            <span> {nextShowing.time}</span>
          </a>
        </div>
        <div>
          {times.map((time, i) => {
            const formattedTime = time.time.split('-')
            return (
              <span className={styles.TimeListV2} key={`ShowTime-${i}`}>
                <Icon type="clock" width={26} a11yText="Time" />
                <a href={time.link} target="_blank" rel="noreferrer">
                  <strong> {formattedTime[0]}</strong>
                  <span> - </span>
                  <span> {formattedTime[1]}</span>
                </a>
              </span>
            )
          })}
        </div>
      </li>
    )
  }

  return (
    <li className={classNames(styles.ShowTime)}>
      <div className={styles.Location}>
        <Icon
          className={styles.AccessTimeIcon}
          type="access-time"
          width={32}
          a11yText="Location"
        />

        <Type as="span" size="base">
          {location} ({distance} mi)
        </Type>
      </div>
      <div className={styles.TimeTable}>
        <span className={styles.NextShowing}>
          <Icon
            className={styles.ClockIcon}
            type="clock"
            width={32}
            a11yText="Time"
          />
          <a href={nextShowing.link} target="_blank" rel="noreferrer">
            <Type as="span" size="base">
              Next Showing: {nextShowing.time}
            </Type>
          </a>
        </span>
        <div className={styles.Times}>
          {times.map((time, i) => (
            <span className={styles.Time} key={`ShowTime-${i}`}>
              <Icon
                className={styles.ClockIcon}
                type="clock"
                width={32}
                a11yText="Time"
              />
              <a href={time.link} target="_blank" rel="noreferrer">
                {time.time}
              </a>
            </span>
          ))}
        </div>
      </div>
    </li>
  )
}

export default ShowTime

ShowTime.propTypes = showTimesPropTypes
